import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { PrintManagerService } from './print-manager.service';

export const Ng1PrintManagerModule = angular
  .module('control-room.shared.services.print-manager', [])
  .factory('crPrintManagerService', downgradeInjectable(PrintManagerService));
